
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 580.8 580.8","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M495.8 85C440.9 30.2 368 0 290.4 0S139.9 30.2 85.1 85.1C30.3 139.9 0 212.9 0 290.4 0 368 30.2 440.9 85.1 495.7c54.8 54.8 127.8 85.1 205.3 85.1 77.6 0 150.5-30.2 205.3-85.1 54.8-54.8 85.1-127.8 85.1-205.3 0-77.6-30.2-150.5-85-205.4zM290.4 537.2c-136.1 0-246.8-110.7-246.8-246.8S154.3 43.5 290.4 43.5s246.8 110.7 246.8 246.8-110.7 246.9-246.8 246.9z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M415.3 210.5c-10.5-11-22.3-11.1-27.7-11.7-38.7-2.8-96.8-2.8-96.8-2.8h-.1s-58.1 0-96.8 2.8c-5.4.6-17.2.7-27.7 11.7-8.3 8.4-11 27.4-11 27.4s-2.7 22.4-2.7 44.8v21c0 22.4 2.8 44.8 2.8 44.8s2.7 19.1 11 27.5c10.5 11 24.3 10.7 30.5 11.8 22.1 2.1 94 2.8 94 2.8s58.1-.1 96.8-2.9c5.4-.7 17.2-.7 27.7-11.7 8.3-8.4 11-27.4 11-27.4s2.8-22.4 2.8-44.8v-21c0-22.4-2.8-44.8-2.8-44.8s-2.7-19.1-11-27.5zM262.2 329.1v-77.7l74.6 39-74.6 38.7z"}})])
          )
        }
      }
    